"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFilter = exports.convertExtendedFilter = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var ObjRefConverter_1 = require("./ObjRefConverter");
var convertObjRefInScopeToRefWithoutIdentifier = function (ref) {
    if (sdk_model_1.isIdentifierRef(ref)) {
        throw new Error("Cannot convert ref specified by identifier");
    }
    return ref;
};
var convertMeasureValueFilter = function (filter) {
    var measureObjQualifier = sdk_model_1.measureValueFilterMeasure(filter);
    if (sdk_model_1.isIdentifierRef(measureObjQualifier)) {
        throw new Error("Cannot convert measure value filter for measure specified by identifier");
    }
    return {
        measureValueFilter: {
            measure: measureObjQualifier,
            condition: sdk_model_1.measureValueFilterCondition(filter),
        },
    };
};
var convertRankingFilter = function (filter) {
    var _a = filter.rankingFilter, measure = _a.measure, attributes = _a.attributes, operator = _a.operator, value = _a.value;
    return {
        rankingFilter: {
            measures: [convertObjRefInScopeToRefWithoutIdentifier(measure)],
            attributes: attributes === null || attributes === void 0 ? void 0 : attributes.map(convertObjRefInScopeToRefWithoutIdentifier),
            operator: operator,
            value: value,
        },
    };
};
var convertRelativeDateFilter = function (filter) {
    return {
        relativeDateFilter: tslib_1.__assign({ dataSet: ObjRefConverter_1.toBearRef(sdk_model_1.filterObjRef(filter)) }, sdk_model_1.relativeDateFilterValues(filter)),
    };
};
var convertAbsoluteDateFilter = function (filter) {
    return {
        absoluteDateFilter: tslib_1.__assign({ dataSet: ObjRefConverter_1.toBearRef(sdk_model_1.filterObjRef(filter)) }, sdk_model_1.absoluteDateFilterValues(filter)),
    };
};
var convertNegativeAttributeFilter = function (filter) {
    var elements = sdk_model_1.filterAttributeElements(filter);
    return {
        negativeAttributeFilter: {
            displayForm: ObjRefConverter_1.toBearRef(sdk_model_1.filterObjRef(filter)),
            notIn: sdk_model_1.isAttributeElementsByRef(elements) ? elements.uris : elements.values,
        },
    };
};
var convertPositiveAttributeFilter = function (filter) {
    var elements = sdk_model_1.filterAttributeElements(filter);
    return {
        positiveAttributeFilter: {
            displayForm: ObjRefConverter_1.toBearRef(sdk_model_1.filterObjRef(filter)),
            in: sdk_model_1.isAttributeElementsByRef(elements) ? elements.uris : elements.values,
        },
    };
};
exports.convertExtendedFilter = function (filter) {
    if (sdk_model_1.isMeasureValueFilter(filter)) {
        return convertMeasureValueFilter(filter);
    }
    else if (sdk_model_1.isRankingFilter(filter)) {
        return convertRankingFilter(filter);
    }
    else {
        return exports.convertFilter(filter);
    }
};
exports.convertFilter = function (filter) {
    if (sdk_model_1.isPositiveAttributeFilter(filter)) {
        return convertPositiveAttributeFilter(filter);
    }
    else if (sdk_model_1.isNegativeAttributeFilter(filter)) {
        return convertNegativeAttributeFilter(filter);
    }
    else if (sdk_model_1.isAbsoluteDateFilter(filter)) {
        return convertAbsoluteDateFilter(filter);
    }
    else {
        return convertRelativeDateFilter(filter);
    }
};
//# sourceMappingURL=FilterConverter.js.map